define.alias("checkout/components/seamless-checkout", "calendar/components/seamless-checkout");